import Viewports from '../../components/fsUtils/Viewports';

class screenLock {

    constructor() {
        this.body = document.getElementsByTagName('body')[0];
        this.header = document.getElementById('header-wrapper');
        this.secondNav = document.querySelector('.section-nav');
        this.lastYOffset = 0;

        this.viewport = new Viewports({
            'mobile': 767
        });

    }

    lockScreen() {
        this.lastYOffset = window.pageYOffset;
        if (!this.body.classList.contains('screen-lock')) {
            this.body.style.top = (this.lastYOffset * -1) + 'px';
            this.body.classList.add('screen-lock');
        }
        this.header.classList.add('visible');
        if (this.secondNav) this.secondNav.classList.add('fixed');

    }

    unlockScreen() {
        let yPos = (this.body.style.top.replace(/[^-\d\.]/g, '') * -1);
        this.body.style.top = null;
        this.header.classList.remove('visible');
        if (this.secondNav) this.secondNav.classList.remove('fixed');
        this.body.classList.remove('screen-lock');
        window.scrollTo(0, yPos);
    }
}

export default screenLock;